initslide();

$(document).on('shopify:section:load', function(event) {
  initslide();
});
$(document).on('shopify:section:unload', function(event) {
  $('.u-testim-slider').slick('unslick');
});
function initslide() {
    $('.u-testim-slider').slick({
    infinite: true,
    speed: 400,
    autoplay: true,
    slidesToShow: 3,
    pauseOnHover: false,
    slidesToScroll: 3,
    arrows: false,
    centerMode: true,
    centerPadding: '0px',
    adaptiveHeight: true,
    autoplaySpeed: 5000,
    dots: true,
    responsive: [ 
      {
        breakpoint: 991,
        settings: {
         centerMode: false,
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },      
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false
        }
      }
    ]
  });
}

document.addEventListener('DOMContentLoaded', function () {
  // Select all uinventory blocks on the page
  document.querySelectorAll('.uinventory-box').forEach(function(box) {
    var min = parseInt(box.dataset.minnumber, 10);
    var max = parseInt(box.dataset.maxnumber, 10);
    var productId = box.dataset.productid;
    var storageKey = "uinventory_number_" + productId;

    // Check if number already exists in localStorage
    var savedNumber = localStorage.getItem(storageKey);

    if (savedNumber === null) {
      var randomNum = Math.floor(Math.random() * (max - min + 1)) + min;
      localStorage.setItem(storageKey, randomNum);
      savedNumber = randomNum;
    }

    // Output number
    var target = box.querySelector('.u-random-number');
    if (target) {
      target.textContent = savedNumber;
    }
  });
});
